<template>
  <v-container fill-height fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">
                  <div>{{ $t('labels.tokensTitle') }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <span class="token-info"
                  >{{ $t('labels.tokensPro') }} <b>{{ client.token_pro }}</b
                  ><br
                /></span>
                <span class="token-info"
                  >{{ $t('labels.tokens2fa') }} <b>{{ client.token_2fa }}</b
                  ><br /><br
                /></span>
                <div class="token-explanation">
                  {{ $t('labels.tokensExplanation') }}<br /><br />
                  <b>{{ $t('labels.tokenExplanationGeneralTitle') }}:</b><br />
                  {{ $t('labels.tokenExplanationGeneralPerEvent') }}<br />
                  {{ $t('labels.tokenExplanationGeneralPerQuestion')
                  }}<br /><br />
                  {{ $t('labels.tokenExplanationGeneral2fa') }}<br /><br />
                  <b>{{ $t('labels.tokenExplanationAuthorizersTitle') }}:</b
                  ><br />
                  {{ $t('labels.tokenExplanationAuthorizersZero') }}<br />
                  {{ $t('labels.tokenExplanationAuthorizersOne') }}<br />
                  {{ $t('labels.tokenExplanationAuthorizersTwo') }}<br />
                  {{ $t('labels.tokenExplanationAuthorizersN') }}<br />
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout mt-3 row wrap>
          <v-spacer></v-spacer>
          <v-flex md4 sm8 xs12>
            <v-card class="elevation-0 bordered-card">
              <v-card-title>
                <div class="title">{{ $t('labels.tokensFormTitle') }}</div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('fields.tokensPro')"
                  :mask="'######'"
                  :suffix="$t('labels.piece')"
                  v-model="form.tokens_pro"
                />
                <v-text-field
                  :label="$t('fields.tokens2fa')"
                  :mask="'######'"
                  :suffix="$t('labels.piece')"
                  v-model="form.tokens_2fa"
                />
                <v-textarea
                  :label="$t('fields.message')"
                  v-model="form.message"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="sendClick" color="success">{{
                  $t('buttons.buy')
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Upgrade',
  data() {
    return {
      form: {
        tokens_pro: 0,
        tokens_2fa: 0,
        message: '',
      },
      client: {
        token_playground: 0,
        token_pro: 0,
        token_2fa: 0,
      },
    }
  },
  watch: {},
  methods: {
    sendClick() {
      this.$verify(this.$t('alerts.tokenPurchaseRequestQuestion'), result => {
        if (result) {
          this.$APICall(
            'post',
            'PURCHASE',
            '',
            this.form,
            () => {
              this.$alert(this.$t('alerts.purchase'))
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },
  },
  mounted() {
    this.$APICall(
      'get',
      'USER_PROFILE',
      '',
      {},
      data => {
        this.client = data.data.client
      },
      true,
      error => {
        handle_session_error(error, this.$store, this.$router, this.$prompt)
      }
    )
  },
}
</script>

<style scoped>
.bordered-card {
  border: 2px solid #e8e8e8 !important;
}

.token-info {
  font-size: 17px;
}

.token-explanation {
  color: rgb(107, 107, 107);
}
</style>
